import { mapActions, mapGetters, mapMutations } from "vuex";

import { minLength, maxLength, required } from "vuelidate/lib/validators";

export default {
    name: "fast-buy",
    data() {
        return {
            payload: {
                name: "",
                phone: "",
                product_id: "",
                count: 1,
            },
            validationErrors: {},
        };
    },
    validations: {
        payload: {
            phone: {
                required,
                minLength: minLength(19),
            },
            name: {
                required,
                minLength: minLength(3),
                maxLength: maxLength(20),
            },
        },
    },
    watch: {},
    computed: {
        ...mapGetters({
            popupFastBuy: `card/popupFastBuy`,
            fastBuyLoading: `basket/fastBuyLoading`,
        }),
        nameErrors() {
            let error = [];
            if (!this.$v.payload.name.$dirty) {
                return error;
            }
            if (!this.$v.payload.name.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.name.minLength) {
                error.push(this.$t("validationMin") + " 3");
            }
            if (!this.$v.payload.name.maxLength) {
                error.push(this.$t("validationMax") + " 20");
            }
            if (this.validationErrors.name) {
                this.validationErrors.name.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
        phoneErrors() {
            let error = [];
            if (!this.$v.payload.phone.$dirty) {
                return error;
            }
            if (!this.$v.payload.phone.required) {
                error.push(this.$t("validationRequired"));
            }
            if (!this.$v.payload.phone.minLength) {
                error.push(this.$t("validationMin").replace(":count", 12));
            }
            if (this.validationErrors.phone) {
                this.validationErrors.phone.forEach(row => {
                    error.push(row);
                });
            }
            return error;
        },
    },
    methods: {
        ...mapActions({
            fastBuy: `basket/FAST_BUY`,
        }),
        ...mapMutations({
            changeFastBuy: `card/CHANGE_POPUP_FAST_BUY`,
        }),
        isLetter(event) {
            var key = event.keyCode || event.which;
            key = String.fromCharCode(key);

            var regex = /^[A-Za-zА-Яа-яЁёЄєІіЇї \s]+$/;
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        },
        submit() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                let obj = {};
                obj.name = this.payload.name;
                obj.phone = this.payload.phone.replace(/[\s.,%()-]/g, "");
                obj.product_id = this.popupFastBuy.product_id;
                obj.count = this.popupFastBuy.count;
                this.fastBuy(obj)
                    .then(() => {
                        this.$toasted.success(this.$t("successCreateFastBuy"));
                        this.changeFastBuy(false, {
                            show: false,
                        });
                    })
                    .catch(error => {
                        if (error.response.status === 418) {
                            this.$toasted.error(error.response.data.data.error.message);
                        }
                        if (error.response.status === 422) {
                            this.$toasted.error(error.response.data.message);
                        }
                    });
            }
        },
    },
    created() {},
    destroyed() {},
};
